var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"video"}},[(!_vm.browserSupported && _vm.videoSourceLoaded)?_c('div',{attrs:{"id":"not-suporrted"}},[_c('p',[_vm._v("このブラウザーは配信を見ることができません")])]):_vm._e(),_vm._m(0),_c('audio',{attrs:{"id":"audio-view"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-area"},[_c('video',{attrs:{"id":"video-tile"}})])
}]

export { render, staticRenderFns }